import { toast } from "sonner";
import { api, errMsg, fmtDateTime } from "@/lib/api";
import { DemoBadge, Empty, ErrorBox, PageHead, Spinner, StatusBadge, useFetch } from "@/components/common";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

function RequestItem({ r, onCancel }) {
  return (
    <div className="surface space-y-2 p-4" data-testid={`request-${r.id}`}>
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="text-sm font-bold">{r.benefit_name}</p>
          <p className="text-xs text-slate-500">{r.beneficiary_name} · {r.provider_name}</p>
        </div>
        <div className="flex gap-1">{r.is_demo && <DemoBadge />}<StatusBadge status={r.status} testId="request-status" /></div>
      </div>
      <p className="text-xs font-medium text-slate-700">{fmtDateTime(r.scheduled_at)}</p>
      {["REQUESTED", "CONFIRMED"].includes(r.status) && (
        <button className="btn-danger btn-sm" onClick={() => onCancel(r.id)} data-testid={`cancel-request-${r.id}`}>Cancel request</button>
      )}
    </div>
  );
}

export default function Activity() {
  const reqs = useFetch("/customer/service-requests");
  const act = useFetch("/customer/activity");
  const cancel = async (id) => {
    if (!window.confirm("Cancel this request?")) return;
    try { await api.post(`/customer/service-requests/${id}/cancel`); toast.success("Request cancelled"); reqs.reload(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div>
      <PageHead eyebrow="Activity" title="Requests & usage" />
      <Tabs defaultValue="requests">
        <TabsList className="mb-4 grid w-full grid-cols-2 rounded-xl">
          <TabsTrigger value="requests" data-testid="activity-tab-requests">Service requests</TabsTrigger>
          <TabsTrigger value="usage" data-testid="activity-tab-usage">Benefit usage</TabsTrigger>
        </TabsList>
        <TabsContent value="requests" className="space-y-3">
          {reqs.loading && <Spinner />}
          <ErrorBox error={reqs.error} />
          {reqs.data?.length === 0 && <Empty title="No requests yet" />}
          {reqs.data?.map((r) => <RequestItem key={r.id} r={r} onCancel={cancel} />)}
        </TabsContent>
        <TabsContent value="usage" className="space-y-3">
          {act.data?.usage?.length === 0 && <Empty title="No benefits used yet" />}
          {act.data?.usage?.map((u) => (
            <div key={u.id} className="surface flex items-center justify-between p-4" data-testid={`usage-${u.id}`}>
              <div><p className="text-sm font-semibold">−{u.quantity} benefit used</p><p className="text-xs text-slate-500">{u.beneficiary_name} · {fmtDateTime(u.created_at)}</p></div>
              {u.is_demo && <DemoBadge />}
            </div>
          ))}
        </TabsContent>
      </Tabs>
    </div>
  );
}
